import { Fragment, useEffect, useRef, useState } from "react";
import {
  addLifeEventDetails,
  editLifeEventDetails,
  getLifeEventData,
  getLifeEventDetails,
} from "../../homepurchase.service";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Loading } from "app/components";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { formatDate } from "app/utils/utility.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import { InputTextarea } from "primereact/inputtextarea";
import { NumericFormat } from "react-number-format";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";

const initialState = {
  name: "",
  plannedDate: "",
  completionDate: null,
  action: "",
};

const AddLifeEvents = ({
  lifeEventModal,
  handleLifeEventModal,
  title,
  values,
  setValues,
}) => {
  const toast = useRef();

  const [formSubmitted, setFormSubmitted] = useState(false);
  const options = ["Recurring", "One Time"];
  const frequency = [
    { name: "Monthly" },
    { name: "Quarterly" },
    { name: "Half Yearly" },
    { name: "Annual" },
  ];
  const [searchParams] = useSearchParams();
  const sessionValues = getSessionUserInformation();
  const clientId = searchParams.get("clientid");
  const userId = clientId && clientId !== "null" ? clientId : sessionValues.id;
  const [isLoading, setIsLoading] = useState(false);

  const [isInvalidDate, setIsInvalidDate] = useState(false);
  const [lifeEventDetails, setLifeEventDetails] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [lifeEventData, setLifeEventData] = useState([]);
  const [date, setDate] = useState(null);
  const calRef = useRef(null);
  const DATE_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;

  const [label, setLabel] = useState("");
  const onHide = () => {
    setFormSubmitted(false);
    setValues(initialState);
    handleLifeEventModal(false);
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const navigate = useNavigate();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const validateInput = () => {
    if ((!values.eventname && !values.eventname1) || !values.plannedDate || !values.selectedOption ||
    !values.plannedExpense || (values.selectedOption === "Recurring" && !values.frequency)) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    let label = title.indexOf("Add") > -1 ? "Add" : "Save";
    setLabel(label);
    if(title.indexOf("Edit") > -1) {
      values.eventname1 = values.eventname;
      setSelectedOption(values?.selectedOption);
    }
    
    const fetchLifeEventDetails = async () => {
      const userId =
        clientId && clientId !== "null" ? clientId : sessionValues.id;
      let list = await getLifeEventDetails(userId);
      if (list) {
        setIsLoading(false);
        if (list) {
          list.map((li, index) => (li.srNo = index + 1));
        }
        setLifeEventDetails(list);
      }
    };
    const fetchLifeEventData = async () => {
      const userId =
        clientId && clientId !== "null" ? clientId : sessionValues.id;
      let list = await getLifeEventData(userId);
      if (list) {
        setIsLoading(false);
   
        setLifeEventData(list);
      }
    };
    fetchLifeEventDetails();
    fetchLifeEventData();
  }, [lifeEventModal]);

  const handleDropdownChange = async (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const handleInputChangeNumber = (name, e) => {
    let value = e.target.value.replace(/[$,]/g, "");

    setValues({
      ...values,
      [name]: parseFloat(value),
    });
  };
  /**
   * Validates mm/dd/yyyy shape and real calendar validity.
   * Returns true if valid, false otherwise.
   */
  function validateMMDDYYYY(text) {
    if (!text || typeof text !== "string") return false;
    // allow 1 or 2 digit month/day, but prefer two-digit shape here:
    const shape = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/;
    if (!shape.test(text)) return false;

    const [mm, dd, yyyy] = text.split("/").map(Number);
    const parsed = new Date(yyyy, mm - 1, dd);
    return (
      parsed.getFullYear() === yyyy &&
      parsed.getMonth() === mm - 1 &&
      parsed.getDate() === dd
    );
  }

  /**
   * Convert Date object -> YYYY-MM-DD (ISO date without time)
   */
  function toIsoDateString(date) {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}`;
  }

  const handleBlur = (e) => {
    // e.target.value may be undefined depending on primereact version
    const typed = e?.target?.value;
    if (!typed) return; // empty allowed — no validation error

    if (!validateMMDDYYYY(typed)) {
      toast.current?.show({
        severity: "error",
        summary: "Invalid date",
        detail: "Please enter a valid date in MM/DD/YYYY format.",
        life: 4000,
      });
      //setValues((s) => ({ ...s, completionDate: "" }));
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput()) {
      return false;
    }
    let details;
    setIsLoading(true);
    let msg = "";

    if (title.indexOf("Add") !== -1) {
      details = await addLifeEventDetails(values);
      msg = "Event added successfully";
    } else {
      if(selectedOption !== "Recurring") values.frequency = "";
      details = await editLifeEventDetails(values, values?.id);
      msg = "Event updated successfully";
    }
    if (details) {
      showSuccess(msg);

      setTimeout(() => {
        onHide();
      }, 1000);
    } else {
      showError(details?.message);
    }
    setIsLoading(false);
  };
  const renderFooter = () => {
    return (
      <div>
        <div className="grid">
          <div className="col-3"></div>
          <div
            className={`${
              isDesktopOrLaptop ? "col-7" : "col-12 text-align-center"
            }`}
          >
            <Button
              label="Cancel"
              className="p-button-raised p-button-lg"
              onClick={() => onHide()}
            />
            <Button
              type="submit"
              label={label}
              className={`p-button-raised p-button-warning p-button-lg  ${
                isDesktopOrLaptop ? "" : "ml-4"
              }`}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      header={title}
      visible={lifeEventModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "35vw" }}
      footer={renderFooter()}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      <div className="center-align">
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className="AddPropertyForm">
          <div className={`mt-4 ${isDesktopOrLaptop ? "text-right" : ""}`}>
            <div className="grid">
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Add new Life Event</label>
              </div>
               

      
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <Dropdown
                        className="vw-dropdown zipcode-dropdown"
                        value={values?.eventname}
                        options={lifeEventData}
                        required={true}
                        name="eventname"
                        editable
                        placeholder="Please select event"
                        onChange={handleDropdownChange}
                        optionLabel="name" // Display the name in the dropdown
                        optionValue="name"
                        style={{
                          border: "1px solid #ced4da", // Customize the border color and width
                          borderRadius: "3px", // Optional: round the corners
                          padding: "5px", // Optional: add padding for spacing
                        }}
                      />
                    </span>
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.eventname &&  !values.eventname1 && (
                      <small className="p-error">
                        Please select event name
                      </small>
                    )}
                  </div>
                </div>
              </div>

              {/* Planned Date */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Planned Date</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <Calendar
                      onBlur={handleBlur}
                      id="buttondisplay"
                      onChange={(date) =>
                        setValues({
                          ...values,
                          plannedDate: new Date(
                            Date.UTC(
                              date.value.getFullYear(),
                              date.value.getMonth(),
                              date.value.getDate()
                            )
                          )
                            .toISOString()
                            .split("T")[0],
                        })
                      }
                      value={
                        values?.plannedDate
                          ? new Date(formatDate(values?.plannedDate))
                          : ""
                      }
                      showIcon
                      dateFormat="mm/dd/yy"
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.plannedDate && (
                      <small className="p-error">
                        Please enter planned date
                      </small>
                    )}
                    {isInvalidDate && (
                      <small className="p-error">
                        Please enter valid planned date
                      </small>
                    )}
                  </div>
                </div>
              </div>
              {/* Completion date */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Completion Date</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <Calendar
                      id="buttondisplay"
                      onBlur={handleBlur}
                      onChange={(date) => {
                      
                        let d = date.value ? new Date(
                            Date.UTC(
                              date?.value?.getFullYear(),
                              date?.value?.getMonth(),
                              date?.value?.getDate()
                            )
                          )
                            .toISOString()
                            .split("T")[0] : null;

                        setValues({
                          ...values,
                          completionDate: d
                        
                        })
                      }
                      }
                      value={
                        values?.completionDate
                          ? new Date(formatDate(values?.completionDate))
                          : null
                      }
                      showIcon
                      dateFormat="mm/dd/yy"
                    />
                  </div>
                </div>
              </div>

              {/*Planned Expenses */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Planned Expenses</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      name="plannedExpense"
                      prefix="$ "
                      value={values?.plannedExpense}
                      decimalScale={0}
                      allowNegative={false}
                      onBlur={(e) => {
                        handleInputChangeNumber("plannedExpense", e);
                      }}
                    ></NumericFormat>
                  </div>
                  <div className="text-align-left mt-4">
                    {formSubmitted && !values?.plannedExpense && (
                      <small className="p-error">
                        Please enter planned expense
                      </small>
                    )}
                 
                  </div>
                </div>
              </div>
              <div
                className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}
              ></div>
              <div className="col-7">
                <div className="flex ">
                  {options.map((plan) => (
                    <div className="flex align-items-center gap-2 ml-4">
                      <RadioButton
                        value={plan}
                        checked={values.selectedOption === plan}
                        onChange={(e) => {
                          setSelectedOption(e.target.value);

                          setValues({
                            ...values,
                            selectedOption: e.target.value,
                          });
                        }}
                      />
                      <label>{plan}</label>
                    </div>
                  ))}
                  
                </div>
                 <div className="text-align-left mt-4">
                    {formSubmitted && !values?.selectedOption && (
                      <small className="p-error">
                        Please select option
                      </small>
                    )}
                 
                  </div>
              </div>
                 
              {selectedOption === "Recurring" && (
              <Fragment>
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <Dropdown
                        className="vw-dropdown zipcode-dropdown"
                        value={values?.frequency}
                        options={frequency}
                        required={true}
                        name="frequency"
                        placeholder="Please select frequency"
                        onChange={handleDropdownChange}
                        optionLabel="name" // Display the name in the dropdown
                        optionValue="name"
                        style={{
                          border: "1px solid #ced4da", // Customize the border color and width
                          borderRadius: "3px", // Optional: round the corners
                          padding: "5px", // Optional: add padding for spacing
                        }}
                      />
                  </div>
                   <div className="text-align-left mt-4">
                    {formSubmitted && values?.selectedOption === "Recurring" && !values.frequency && (
                      <small className="p-error">
                        Please select frequency
                      </small>
                    )}
                 
                  </div>
                </div>
              </div>
               
              </Fragment>
              )}

              {/* Notes */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Notes</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <InputTextarea
                      className="my-textarea"
                      value={values?.notes}
                      onChange={(e) =>
                        setValues({
                          ...values,
                          notes: e.target.value ? e.target.value : null,
                        })
                      }
                      rows={3}
                      maxLength={200}
                      showCount
                      autoResize
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default AddLifeEvents;
